<template>
    <div class="swiper" ref="swiperRef">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="channelImage of channelImageList">
                <div class="img-box">
                    <img :src="channelImage" alt="" />
                </div>
            </div>
        </div>
        <div class="swiper-pagination" ref="swiperPaginationRef"></div>
    </div>
</template>
<script >
// 图片轮播组件
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue-demi';
import { activeImage, changeImage } from '../common/store';
const __sfc_main = {};
__sfc_main.props = {
  channelImageList: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = useEnv?.() || {};
  const props = __props;
  let swiperIns = null;
  const swiperRef = ref(null);
  const swiperPaginationRef = ref(null);
  function initSwiper() {
    if (swiperRef.value) {
      // 获取当前的图片索引，用于初始化时保持当前显示的图片
      const currentImageIndex = activeImage.value;
      // 确保索引在有效范围内
      const validIndex = Math.max(0, Math.min(currentImageIndex, props.channelImageList.length - 1));
      swiperIns = new Swiper(swiperRef.value, {
        // 一次显示的图片数量
        slidesPerView: 'auto',
        modules: [Pagination],
        centeredSlides: true,
        spaceBetween: 0,
        // 设置初始 slide，保持当前显示的图片
        initialSlide: validIndex,
        pagination: {
          el: swiperPaginationRef.value,
          clickable: true
        },
        on: {
          slideChange: function (swiper) {
            changeImage(swiper.activeIndex);
          }
        }
      });
    }
  }
  function destroySwiper() {
    if (swiperIns) {
      swiperIns?.destroy();
    }
  }
  watch(() => props.channelImageList, () => {
    destroySwiper();
    nextTick(initSwiper);
  });
  onMounted(() => {
    !isPreRender && initSwiper();
  });
  onBeforeUnmount(() => {
    destroySwiper();
  });
  return {
    swiperRef,
    swiperPaginationRef
  };
};
export default __sfc_main;
</script>
<style lang="less" scoped>
.swiper {
    width: 100%;
    height: 100%;
    width: 7.5rem;
    height: 5.04rem;
    .swiper-slide {
        text-align: center;
        width: 3.42rem;
        height: 4.56rem;
        margin: 0;

        /* Center slide text vertically */
        display: flex;
        justify-content: center;
        align-items: center;

        & > .img-box {
            width: 2.4rem;
            height: 3.2rem;
            position: relative;
            & > img {
                width: 2.4rem;
                height: 3.2rem;
                object-fit: contain;
            }
        }

        &.swiper-slide-active {
            & > .img-box {
                width: 3.42rem;
                height: 4.56rem;
                border-radius: 0.12rem;
                overflow: hidden;
                & > img {
                    width: 3.42rem;
                    height: 4.56rem;
                    border-radius: 0.12rem;
                    border: 0.02rem solid #ff6900;
                }

                &::before {
                    position: absolute;
                    top: 0;
                    right: -0.64rem;
                    content: '';
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border: 0.64rem solid transparent;
                    border-top-color: #ff6900;
                }

                &::after {
                    content: '';
                    position: absolute;
                    display: inline-block;
                    top: 0.12rem;
                    right: 0.12rem;
                    width: 0.16rem;
                    height: 0.16rem;
                    background: url('../images/selected.svg') no-repeat center;
                    background-size: 0.16rem 0.16rem;
                }
            }
        }

        &.swiper-slide-prev {
            justify-content: flex-end;
            padding-right: 0.16rem;
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(255, 255, 255, 0.7);
            }
        }

        &.swiper-slide-next {
            justify-content: flex-start;
            padding-left: 0.16rem;
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(255, 255, 255, 0.7);
            }
        }
    }

    .swiper-pagination {
        bottom: 0;
        font-size: 0.08rem;
        /deep/ .swiper-pagination-bullet-active {
            background: #0f1112;
        }

        /deep/ .swiper-pagination-bullet {
            border-radius: 50%;
            width: 0.08rem;
            height: 0.08rem;
        }
    }
}
</style>
